module.exports = __webpack_public_path__ + "static/media/material_arrow_up.21e83a73.svg";